<template>
  <div>
    <iframe width="100%" height="650px"
      src="https://lookerstudio.google.com/embed/reporting/087e4802-f9ae-451b-8f71-33149057c8ef/page/zgsCD"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
